/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  shortTermAvailability meta reducer
 */

import { nullReducer, payloadKeyReducer } from '@zcode/reducers'
import { combineReducers } from 'redux'
import { combineActions, handleActions } from 'redux-actions'
import {
  CLEAR_SHORT_TERM_AVAILABILITY,
  DONE_FETCHING_SHORT_TERM_AVAILABILITY,
  ERROR_FETCHING_SHORT_TERM_AVAILABILITY,
  RECEIVE_SHORT_TERM_AVAILABILITY,
  START_FETCHING_SHORT_TERM_AVAILABILITY,
} from '../constants/index'

const metaReducer = combineReducers({
  error: handleActions(
    {
      [ERROR_FETCHING_SHORT_TERM_AVAILABILITY]: payloadKeyReducer('error'),
      [combineActions(CLEAR_SHORT_TERM_AVAILABILITY, START_FETCHING_SHORT_TERM_AVAILABILITY)]:
        nullReducer,
    },
    null
  ),
  fetching: handleActions(
    {
      [START_FETCHING_SHORT_TERM_AVAILABILITY]: () => true,
      [combineActions(CLEAR_SHORT_TERM_AVAILABILITY, DONE_FETCHING_SHORT_TERM_AVAILABILITY)]: () =>
        false,
    },
    false
  ),
  fetchingKey: handleActions(
    {
      [START_FETCHING_SHORT_TERM_AVAILABILITY]: payloadKeyReducer('key'),
      [combineActions(CLEAR_SHORT_TERM_AVAILABILITY, DONE_FETCHING_SHORT_TERM_AVAILABILITY)]:
        nullReducer,
    },
    null
  ),
  currentKey: handleActions(
    {
      [CLEAR_SHORT_TERM_AVAILABILITY]: nullReducer,
      [RECEIVE_SHORT_TERM_AVAILABILITY]: payloadKeyReducer('key'),
    },
    null
  ),
})

// eslint-disable-next-line import/no-default-export
export default metaReducer
